module.exports = __webpack_public_path__ + "img/send_btn.b6ad7738.png";